import React from 'react'
import { Link } from 'react-router-dom'

/**
 * Compliance Legal Footer Component.
 * Styled in line with the global CSS design tokens.
 */
export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer 
      style={{
        width: '100%',
        backgroundColor: 'var(--color-surface)',
        borderTop: '1px solid var(--color-border-subtle)',
        padding: 'var(--space-6) var(--space-8)',
        marginTop: 'auto',
        transition: 'background-color var(--transition-base), border-color var(--transition-base)',
      }}
    >
      <div 
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 'var(--space-4)',
        }}
        className="md:flex-row md:justify-between"
      >
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)' }}>
          &copy; {currentYear} <strong>NoTimeToDelay</strong>. All rights reserved.
        </div>
        <div 
          style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: 'var(--space-6)', 
            fontSize: 'var(--text-sm)',
            justifyContent: 'center'
          }}
        >
          <Link 
            to="/privacy" 
            style={{ 
              color: 'var(--color-text-secondary)',
              transition: 'color var(--transition-fast)'
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = 'var(--color-accent)')}
            onMouseOut={(e) => (e.currentTarget.style.color = 'var(--color-text-secondary)')}
          >
            Privacy Policy
          </Link>
          <Link 
            to="/terms" 
            style={{ 
              color: 'var(--color-text-secondary)',
              transition: 'color var(--transition-fast)'
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = 'var(--color-accent)')}
            onMouseOut={(e) => (e.currentTarget.style.color = 'var(--color-text-secondary)')}
          >
            Terms of Service
          </Link>
          <Link 
            to="/data-deletion" 
            style={{ 
              color: 'var(--color-text-secondary)',
              transition: 'color var(--transition-fast)'
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = 'var(--color-accent)')}
            onMouseOut={(e) => (e.currentTarget.style.color = 'var(--color-text-secondary)')}
          >
            Data Deletion
          </Link>
          <Link 
            to="/contact" 
            style={{ 
              color: 'var(--color-text-secondary)',
              transition: 'color var(--transition-fast)'
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = 'var(--color-accent)')}
            onMouseOut={(e) => (e.currentTarget.style.color = 'var(--color-text-secondary)')}
          >
            Contact Support
          </Link>
        </div>
      </div>
    </footer>
  )
}
export default Footer
